import React from "react";
import { Form, Button, Card } from "antd";
import { LeftCircleTwoTone } from "@ant-design/icons";
import { withRouter } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import {
  notificationTitle,
  openNotificationType,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import FormLoader from "swfrontend/MDM/MDMScreens/FormView/FormLoader";
import { localStorageVariableName } from "swfrontend/AppConfigs";
import AuthDataProvider from "../../AuthDataProvider";
import { URLS } from "../../constants";
import { NOTIFICATIONS } from "../../../LandingPage/constants";
import { ErrorLogger } from "../../../App/Utils/ErrorHandler";

class ForgotPasswordContent extends React.Component {
  formRef = React.createRef();
  DataProvider = new AuthDataProvider();

  state = {
    isLoading: false,
  };

  componentDidMount() {
    loadCaptchaEnginge(6);
  }

  onFinish = (values) => {
    if (validateCaptcha(values.captcha)) {
      this.forgetPassword(values);
    } else {
      openNotification(
        openNotificationType.error,
        notificationTitle.form,
        NOTIFICATIONS.INVALID_CAPTCHA
      );
    }
  };

  forgetPassword = (values) => {
    try {
      values.screen = "Forget Password";

      Object.keys(values).forEach((each) => {
        values[each] = window.btoa(values[each].trim());
      });

      this.setState({ isLoading: true });
      this.DataProvider.post_api_call(`${URLS.FORGET_PASSWORD}`, values)
        .then((res) => {
          if (res.ok) {
            return res.json().then((res) => {
              openNotification(
                openNotificationType.success,
                Object.keys(res)[0],
                res.Success
              );

              localStorage.setItem(
                localStorageVariableName.userName,
                values.username
              );
              localStorage.setItem("otp-duration", res.duration);

              this.props.history.push(URLS.RESET_PASSWORD_URL);
            });
          } else {
            return res.json().then((res) => {
              Object.keys(res).map((error) => {
                openNotification(openNotificationType.error, error, res[error]);
              });
            });
          }
        })
        .finally(() => this.setState({ isLoading: false }));
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  goBack = () => {
    this.props.history.push(URLS.LOGIN_URL);
  };

  render() {
    const { isLoading } = this.state;
    return (
      <>
        <Modal show={isLoading} centered>
          <Modal.Body>
            <FormLoader loading="true" />
          </Modal.Body>
        </Modal>

        <Form
          onFinish={this.onFinish}
          layout="vertical"
          ref={this.formRef}
          className="container_bg text-center"
          autoComplete="off"
        >
          <Card
            title="Forget Password"
            className="main_card p-1 card-height"
            extra={
              <Button type="link">
                <LeftCircleTwoTone
                  onClick={this.goBack}
                  className="back-icon"
                />
              </Button>
            }
          >
            <div className="col-lg-12 col-md-12">
              <AndtDTextBoxWrapper
                decorator="username"
                id="Username"
                required="true"
                label="Username"
                message="Enter Username"
                placeholder="Enter Username"
                validators=""
                formRef={this.formRef}
              />
            </div>

            <div className="col-lg-12 col-md-12">
              <AndtDTextBoxWrapper
                decorator="captcha"
                id="captcha"
                required="true"
                label="Captcha"
                message="Enter Captcha"
                placeholder="Enter Captcha"
                validators=""
                formRef={this.formRef}
              />
            </div>

            <div className="col-lg-12 col-md-12">
              <LoadCanvasTemplate />
              <br />
            </div>

            <div className="col-lg-12 col-md-12 text-center">
              <Button htmlType="submit" type="primary" id="verify">
                Verify Login ID
              </Button>
            </div>
          </Card>
        </Form>
        <br />
        <br />
        <br />
      </>
    );
  }
}

export default withRouter(ForgotPasswordContent);
